<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <!-- <template slot="headAction">
        <a-button type="primary" @click="updatePassWord">重置密码</a-button>
      </template>-->
    </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
export default {
  name: "userManage_department",
  components: { DataTable },
  props: {},
  data() {
    return {
      // form: this.$form.createForm(this),
      visible: {
        formModal: false
      }
    };
  },
  created() {
    this.option = {
      // headSearch: {
      //   colnum: 2,
      //   content: []
      // },
      form: {
        colnum: 1,
        width: 500,
        title: "部门",
        add: {
          submitApi: "Department_Add"
        },
        edit: {
          infoApi: "Department_Info",
          submitApi: "Department_Edit"
        },
        del: { submitApi: "Department_Del" },
        content: [
          {
            label: "编码",
            name: "Code",
            option: {
              rules: [{ required: true, message: "请填写编码！" }]
            }
          },
          {
            label: "名称",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请填写名称！" }]
            }
          }
          // {
          //   label: "父级Id",
          //   name: "ParentId",
          //   placeholder: "请选择",
          //   type: "select",
          //   api: "Common_GetSelect",
          //   param: { types: "department" },
          //   dataField: "Data.department"
          // }
        ]
      },
      grid: {
        api: "Department_List",
        pagination: false,
        dataField: "Data",
        columns: [
          {
            title: "序号",
            width: "10%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "编码",
            width: "20%",
            dataIndex: "Code"
          },
          {
            title: "名称",
            width: "20%",
            dataIndex: "Name"
          },
          {
            title: "操作",
            dataIndex: "Id",

            key: "action",
            scopedSlots: { customRender: "rowAction" } //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped></style>
